<script>
export default {
  name: "IconPrivacy"
};
</script>

<template>
  <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M14.916 7.639h-.912V6.18C14.004 2.772 11.31 0 8 0 4.69 0 1.995 2.773 1.995 6.18V7.64h-.91c-.6 0-1.085.5-1.085 1.116v10.128C0 19.5.486 20 1.085 20h13.83c.6 0 1.085-.5 1.085-1.117V8.755c0-.616-.485-1.116-1.084-1.116ZM4.166 6.18c0-2.177 1.72-3.948 3.834-3.948 2.115 0 3.835 1.771 3.835 3.948v1.458h-7.67V6.18Zm9.665 11.586H2.17V9.872H13.83v7.895Z"
      />
      <path
        d="M8 11.708c-.599 0-1.084.5-1.084 1.116v1.666c0 .617.485 1.117 1.085 1.117.599 0 1.084-.5 1.084-1.117v-1.666c0-.616-.485-1.116-1.084-1.116Z"
      />
    </g>
  </svg>
</template>
